import { Box, Button } from "@material-ui/core"
import { MouseEventHandler, useEffect, useRef, useState } from "react"
import { chartStyles } from "../../styles"
import { useI18n } from "providers/I18n"
import { useWindowDimensions } from "../../hooks/useWindowDimensions"
import FadeIn from "../SharedComponents/FadeIn"
import LegendItemsBox from "./LegendItemsBox"

export default function FiltersCharts({
  itemKey,
  legendItems,
  itemIndex,
  availableEntities,
  handleChangeAvailableEntities,
  handleCheckAllEntities,
  handleOpenSettings,
  isOpen,
  handleOpen,
  isExpanded,
  checked,
}: {
  itemKey: string
  legendItems: string[]
  itemIndex: number
  availableEntities: string[][]
  handleChangeAvailableEntities: (idx: number, entity: string) => void
  handleCheckAllEntities: (idx: number, items: string[]) => void
  handleOpenSettings?: (index: number) => void
  isOpen: boolean
  handleOpen: MouseEventHandler<HTMLButtonElement>
  isExpanded?: boolean
  checked: boolean
}) {
  const { t } = useI18n()
  const [hasFiltersScroll, setHasFiltersScroll] = useState(false)

  const dimension = useWindowDimensions()

  const ref = useRef<any>(null)

  useEffect(() => {
    function handleClickOutside(event: { target: any }) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleOpenSettings?.(itemIndex)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [handleOpenSettings, itemIndex, ref])

  useEffect(() => {
    const divScroll = document.getElementById("divScroll")
    setHasFiltersScroll(divScroll?.scrollHeight! > divScroll?.clientHeight!)
  }, [isOpen, hasFiltersScroll, dimension.width])

  return (
    <Box position={isExpanded ? "relative" : "absolute"} right={0} zIndex={9}>
      {isOpen ? (
        <div ref={ref}>
          {!isExpanded ? (
            <FadeIn delay={100} duration={300}>
              <LegendItemsBox
                itemKey={itemKey}
                legendItems={legendItems}
                itemIndex={itemIndex}
                availableEntities={availableEntities}
                handleChangeAvailableEntities={handleChangeAvailableEntities}
                handleOpen={handleOpen}
                handleCheckAllEntities={handleCheckAllEntities}
                checked={checked}
                hasFiltersScroll={hasFiltersScroll}
              />
            </FadeIn>
          ) : (
            <LegendItemsBox
              itemKey={itemKey}
              legendItems={legendItems}
              itemIndex={itemIndex}
              availableEntities={availableEntities}
              handleChangeAvailableEntities={handleChangeAvailableEntities}
              handleOpen={handleOpen}
              isExpanded
              handleCheckAllEntities={handleCheckAllEntities}
              checked={checked}
              hasFiltersScroll={hasFiltersScroll}
            />
          )}
        </div>
      ) : (
        <Button
          variant="contained"
          onClick={handleOpen}
          style={{
            width: "124px",
            height: "44px",
            backgroundColor: "var(--extra-dark-grey)",
            color: "var(--white)",
            borderRadius: "8px",
            padding: "0px, 0px, 16px, 0px",
          }}
          className={chartStyles.selectBtn}
        >
          {t("revenue.select") + itemKey}
        </Button>
      )}
    </Box>
  )
}
